<template>
  <div class="store-country-form">
    <generic-form-element
      v-for="row in formTemplate"
      :key="`store-country.${row.key}`"
      :row="row"
      :form="form"
    />
  </div>
</template>

<script>
import GenericFormElement from '@/components/form/FormElement.vue'

export default {
  name: 'StoreCountryForm',
  components: {
    GenericFormElement,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    const formTemplate = [
      {
        key: 'shipping_info',
        isLocalized: true,
        isDynamicLanguage: true,
        isInObject: true,
      },
      {
        key: 'return_policy',
        isLocalized: true,
        isDynamicLanguage: true,
        isInObject: true,
      },
      { key: 'is_free_shipping', isSwitch: true },
      {
        key: 'free_shipping_info',
        isLocalized: true,
        isDynamicLanguage: true,
        isInObject: true,
      },
      { key: 'is_free_return', isSwitch: true },
      {
        key: 'free_return_info',
        isLocalized: true,
        isDynamicLanguage: true,
        isInObject: true,
      },
    ]

    return {
      formTemplate,
    }
  },
}
</script>

<style lang="scss">
.store-country-form {
  padding: 0 12px;

  .el-form-item {
    display: flex;

    label {
      margin-right: 12px;
      padding-left: 10px;
      flex-shrink: 0;
    }
    .el-form-item__content {
      width: 100%;
    }
  }
}
</style>
